var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6812 0.25C9.26542 0.25 0.812012 8.65 0.812012 19C0.812012 29.35 9.26542 37.75 19.6812 37.75C30.097 37.75 38.5504 29.35 38.5504 19C38.5504 8.65 30.097 0.25 19.6812 0.25ZM19.6812 5.875C22.8135 5.875 25.342 8.3875 25.342 11.5C25.342 14.6125 22.8135 17.125 19.6812 17.125C16.5489 17.125 14.0205 14.6125 14.0205 11.5C14.0205 8.3875 16.5489 5.875 19.6812 5.875ZM19.6812 32.5C14.9639 32.5 10.7938 30.1 8.3597 26.4625C8.4163 22.7312 15.9074 20.6875 19.6812 20.6875C23.4362 20.6875 30.9461 22.7312 31.0027 26.4625C28.5686 30.1 24.3985 32.5 19.6812 32.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.037728700dde490229b4e71e0ae05fbb.svg";
export { ForwardRef as ReactComponent };